import { useCallback, useEffect } from 'react';

import { POPOVER_ID } from '../../../constants';
import { KEY } from '../../../enums';

export const usePopoverEscape = (identifier: string, callback: (popover: string) => void) => {
  const onKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === KEY.ESCAPE) {
        const popovers = document.querySelectorAll(`#${POPOVER_ID}`);
        const nodes = Array.prototype.slice.call(popovers, 0);
        const reverse = nodes.reverse();

        const [popover] = reverse;
        if (popover) {
          const visible = popover.getAttribute('data-visibile');
          const name = popover.getAttribute('data-identifier');
          if (identifier === name && visible === 'true') {
            callback(identifier);
          }
        }
      }
    },
    [identifier, callback]
  );
  useEffect(() => {
    window.addEventListener('keydown', onKeyDown);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [onKeyDown]);
};
